import React from "react";
import PropTypes from "prop-types";

import "./styles/components/CallToActionButton.css";

const CallToActionButton = props => {
  const styles = {
    background: `linear-gradient(to right bottom, ${props.colourPrimary}, ${
      props.colourSecondary
    })`,
    color: props.font_colour
  };

  return (
    <div className={`u-align-${props.align}`}>
      <div
        onClick={props.handleClick}
        className={`btn btn--animated`}
        style={styles}
      >
        {props.text}
      </div>
    </div>
  );
};

CallToActionButton.defaultProps = {
  align: "center",
  font_colour: "#ffffff",
  colourPrimary: "rgba(255,255,255, .85)",
  colourSecondary: "rgba(240,240,240, .85)",
  text: "Button"
};

CallToActionButton.propTypes = {
  handleClick: PropTypes.func.isRequired,
  align: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

export default CallToActionButton;



// WEBPACK FOOTER //
// ./src/components/layout/CallToActionButton.js